import React, { useMemo } from "react";
import { Table, Button, Space, Popconfirm, Tag } from "antd";

const ListTable = ({
  data = [],
  loading = false,
  onEdit = () => {},
  onDelete = () => {},
  zone = [],
}) => {
  const zoneMap = useMemo(() => {
    const map = {};
    zone.forEach((item) => {
      map[item.id] = item.name?.trim();
    });
    return map;
  }, [zone]);

  const columns = [
    {
      title: "Table Name",
      dataIndex: "name",
    },
    {
      title: "Capacity",
      dataIndex: "capacity",
    },
    {
      title: "Zone",
      dataIndex: "zone_id",
      render: (zone_id) => zoneMap[zone_id] || "-",
    },
    {
      title: "AC Type",
      dataIndex: "ac_type",
      render: (ac_type) => {
        const value = String(ac_type || "NON_AC").toUpperCase();

        return (
          <Tag color={value === "AC" ? "blue" : "default"}>
            {value === "AC" ? "AC" : "Non AC"}
          </Tag>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => {
        const value = String(status || "").toLowerCase();

        return (
          <Tag color={value === "occupied" ? "red" : "green"}>
            {value === "occupied" ? "Occupied" : "Available"}
          </Tag>
        );
      },
    },
    {
      title: "Active",
      dataIndex: "is_active",
      render: (is_active) => (
        <Tag color={Number(is_active) === 1 ? "green" : "default"}>
          {Number(is_active) === 1 ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Action",
      render: (_, record) => (
        <Space>
          <Button type="link" onClick={() => onEdit(record)}>
            Edit
          </Button>

          <Popconfirm
            title="Are you sure you want to delete this table?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => onDelete(record.id)}
          >
            <Button danger type="link">
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={data}
      loading={loading}
      pagination={{ pageSize: 10 }}
    />
  );
};

export default ListTable;